<app-upsell-card
  htmlTitle="<strong>Important: Support</strong> Healthy Hair Growth"
  question="Would you like to include Minoxidil as part of your treatment plan?"
  [slug]="slug"
>
  <p class="mb-4">
    Inflammatory skin conditions can sometimes affect the <strong>scalp</strong>, leading to irritation, scratching, and
    temporary hair thinning.
  </p>
  <p class="mb-4">
    <strong>Minoxidil</strong> is a commonly used topical treatment that may help support hair regrowth and improve
    follicle activity. When appropriate, it can be used alongside your prescribed treatment plan.
  </p>
  <p class="mb-4">
    Adding <strong>Minoxidil</strong> may help support healthy hair growth while your treatment works to manage scalp
    inflammation.
  </p>
</app-upsell-card>
